module.exports = __webpack_public_path__ + "static/media/two_collecting_waves_header@2x.2469ca3f.png";